import { render, staticRenderFns } from "./BtFilterWrapperWithPanel.vue?vue&type=template&id=bad4c610&scoped=true&"
import script from "./BtFilterWrapperWithPanel.vue?vue&type=script&lang=js&"
export * from "./BtFilterWrapperWithPanel.vue?vue&type=script&lang=js&"
import style0 from "./BtFilterWrapperWithPanel.vue?vue&type=style&index=0&id=bad4c610&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad4c610",
  null
  
)

export default component.exports